import Vue from 'vue'
import Vuex from 'vuex'
import http from './modules/http'
import items from './modules/items'
import users from './modules/users'
import types from './modules/types'
import files from './modules/files'
import pages from './modules/pages'
import screen from './modules/screen'
import scopes from './modules/scopes'
import tables from './modules/tables'
import values from './modules/values'
import library from './modules/library'
import filters from './modules/filters'
import account from './modules/account'
import columns from './modules/columns'
import bundles from './modules/bundles'
import reports from './modules/reports'
import dossiers from './modules/dossiers'
import excludes from './modules/excludes'
import datasets from './modules/datasets'
import pageItems from './modules/pageItems'
import processes from './modules/processes'
import tableCache from './modules/tableCache'
import accessCodes from './modules/accessCodes'
import columnCategories from './modules/columnCategories'

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  modules: {
    http: http,
    types: types,
    users: users,
    items: items,
    files: files,
    pages: pages,
    screen: screen,
    tables: tables,
    scopes: scopes,
    values: values,
    account: account,
    columns: columns,
    bundles: bundles,
    reports: reports,
    library: library,
    filters: filters,
    datasets: datasets,
    dossiers: dossiers,
    excludes: excludes,
    pageItems: pageItems,
    processes: processes,
    tableCache: tableCache,
    accessCodes: accessCodes,
    columnCategories: columnCategories
  }
})
